import { action } from 'mobx';
import { ModalStore } from 'ui/base/modal';
import { BooleanStore, StringStore } from 'ui/base/input';
import { createDomainFilter } from 'ui/history/site_entry/site_entry_logic';
import { DomainSiteFilter } from 'services/pangolin/types';

function validate(domain: string): boolean {
  /* eslint-disable-next-line no-useless-escape */
  const re = /^((?:(?:(?:\w[\.\-\+]?)*)\w)+)((?:(?:(?:\w[\.\-\+]?){0,62})\w)+)\.(\w{2,6})$/;
  const stripped = domain.trim();
  return re.test(stripped);
}

export class DomainInputStore {
  domain: StringStore;
  modal: ModalStore;
  isValid: BooleanStore;

  constructor() {
    this.domain = new StringStore('');
    this.modal = new ModalStore(false);
    this.isValid = new BooleanStore(true);
  }

  @action.bound
  commit(): DomainSiteFilter | undefined {
    const domain = this.domain.value;
    if (validate(domain)) {
      this.isValid.setValue(true);
      return createDomainFilter(domain);
    }
    this.isValid.setValue(false);
    return undefined;
  }

  @action.bound
  showModal() {
    this.domain.setValue('');
    this.isValid.setValue(true);
    this.modal.showModal();
  }

  @action.bound
  hideModal() {
    this.modal.hideModal();
  }

  @action.bound
  toggleModal() {
    this.modal.visible = !this.modal.visible;
  }
}
